import isServer from '@framework/router/Next/isServer';

export default function isIE() {
  const userAgent = !isServer() ? navigator.userAgent : '';
  return Boolean(userAgent.match(/MSIE|Edge|Trident/i));
}
